export class LoginProfileError extends Error {
  constructor(cause: unknown) {
    super("Přihlášení proběhlo, ale profil se nepodařilo načíst. Zkus to prosím znovu.", { cause });
    this.name = "LoginProfileError";
  }
}

export function loginFailureMessage(status?: number): string {
  if (status === 401) return "Neplatné přihlašovací údaje.";
  if (status === 429) return "Příliš mnoho pokusů o přihlášení. Zkus to prosím za chvíli.";
  if (status === 403) return "K účtu se teď nelze přihlásit. Kontaktuj správce školy.";
  return "Přihlášení se nepodařilo ověřit. Zkontroluj připojení a zkus to znovu.";
}
